import ProductCard from '@/components/ProductCard';
import { Reveal } from '@/components/Reveal';
import { Button } from '@/components/ui/button';
import {
  Carousel,
  CarouselContent,
  CarouselControls,
  CarouselItem,
} from '@/components/ui/carousel';
import Typography from '@/components/ui/typography';
import Band from '@/Layouts/Band';
import SectionLayout from '@/Layouts/SectionLayout';
import { ProductVariant, ShoppeProduct } from '@/types';
import { Link } from '@inertiajs/react';
import { MoveRight } from 'lucide-react';

type Variant = Pick<ProductVariant, 'color' | 'images'>;
type Product = Omit<ShoppeProduct<Variant>, 'code' | 'details'>;

interface ShoppeCategory {
  name: string;
  slug: string;
  products: Product[];
}

interface ShoppeGroup {
  name: string;
  categories: ShoppeCategory[];
}

const ShowGroup = ({ group }: { group: ShoppeGroup }) => {
  return (
    <>
      <Band tone="raised">
        <SectionLayout width="wide" space="lg" className="gap-y-3">
          <Typography.Eyebrow>Shoppe</Typography.Eyebrow>
          <Typography.Display1 className="capitalize">
            {group.name}
          </Typography.Display1>
        </SectionLayout>
      </Band>

      {group.categories.map((category, index) => (
        <Band key={category.slug} tone={index % 2 ? 'surface' : 'raised'} seam>
          <SectionLayout width="wide" space="lg">
            <Reveal className="flex flex-wrap items-end justify-between gap-4">
              {/* h2, not Display3's default h3: Display1 above is this page's
                  only other heading. */}
              <Typography.Display3 as="h2" className="capitalize">
                {category.name}
              </Typography.Display3>
              <Button asChild variant="outline">
                <Link
                  href={route('shoppe.showCategory', category.slug)}
                  className="shrink-0"
                >
                  View all
                  <MoveRight size={16} className="ml-2" />
                </Link>
              </Button>
            </Reveal>

            <Carousel className="flex w-full flex-col gap-6">
              <CarouselContent className="-ml-3">
                {category.products.map((product) => (
                  <CarouselItem
                    key={product.slug}
                    className="flex basis-1/2 pl-3 sm:basis-1/3 lg:basis-1/4 xl:basis-1/5"
                  >
                    <ProductCard product={product} />
                  </CarouselItem>
                ))}
              </CarouselContent>
              <CarouselControls />
            </Carousel>
          </SectionLayout>
        </Band>
      ))}
    </>
  );
};

export default ShowGroup;
